<template>
  <div id="app">
    <component :layout="layout" :is="layout"></component>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { isAuthenticatedUsingGET } from '@/api'

import MainLayout from "./views/layouts/main.vue";
import OuterLayout from "./views/layouts/outer.vue"

const defaultLayout = Cookies.get('token')? "main":"outer";
export default {
  name: "BKK",
  components: {
		MainLayout,
		OuterLayout
    },
    computed: {
		layout() {
			return (this.$route.meta.layout || defaultLayout) + "-layout";
		}
    },
	mounted() {
		let userAgent = window.navigator.userAgent;

		if (userAgent && userAgent.match(/iPhone/i)) {
		   document.documentElement.classList.add('iphone');
		}
	}
};
</script>